export default class FiltroPedidosCanceladosLiquidados {
    constructor () {
        this.UnidadeId = undefined;
        this.ClienteId = undefined;
        this.RepresentanteId = undefined;
        this.NumeroSolicitacao = undefined;
        this.NumeroPedido = undefined;
        this.NumeroParcela = undefined;
        this.NumeroNotaFiscal = undefined;
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        this.NomeProdutoNovo = undefined;
        this.TipoPedido = undefined;
        this.TipoData = undefined;
        this.DataInicio = undefined;
        this.DataTermino = undefined;
        this.PeriodoInicio = undefined;
        this.PeriodoFim = undefined;
        this.DadosClienteAgrupador = undefined;
        this.ComponentesExpandidos = undefined;
    }
}